import { Component } from '@angular/core';

@Component({
  selector: 'ds-forgot-email',
  styleUrls: ['./forgot-email.component.scss'],
  templateUrl: './forgot-email.component.html'
})
/**
 * Component responsible the forgot password email step
 */
export class ForgotEmailComponent {

}
